import React from "react";
import siemensNxBadge from "../../assets/img/certificates/siemens-nx-badge.png";
import siemensNxMasteryBadge from "../../assets/img/certificates/siemens-nx-mastery-badge.png";
import aigpeBlackBelt from "../../assets/img/certificates/aigpe-black-belt.png";
import aigpeGreenBelt from "../../assets/img/certificates/aigpe-green-belt.png";
import aigpeYellowBelt from "../../assets/img/certificates/aigpe-yellow-belt.png";

const certificatesData = [
    {
        name: "Siemens NX",
        title: "Intro to Siemens NX: Engineering Essentials and Part Design",
        issuer: "Siemens (via Coursera)",
        date: "Jan 2026",
        verifyUrl: "https://coursera.org/share/fe3c4fa122e8ce6e8bb33fe1681e1890",
        badge: siemensNxBadge,
        color: "#009999"
    },
    {
        name: "Siemens NX Mastery",
        title: "Siemens NX Mastery: Advanced Design & Applications",
        issuer: "Siemens (via Coursera)",
        date: "Mar 2026",
        verifyUrl: "https://coursera.org/verify/6PNGWQGNGZES",
        badge: siemensNxMasteryBadge,
        color: "#7B2D8B"
    },
    {
        name: "AIGPE Black Belt",
        title: "AIGPE Lean Six Sigma Certified Black Belt",
        issuer: "AIGPE",
        date: "2024",
        verifyUrl: "https://digitalcredentials.aigproexcellence.com/en/verify/89585097266985?ref=email",
        badge: aigpeBlackBelt,
        color: "#000000"
    },
    {
        name: "AIGPE Green Belt",
        title: "AIGPE Lean Six Sigma Certified Green Belt",
        issuer: "AIGPE",
        date: "2024",
        verifyUrl: "https://digitalcredentials.aigproexcellence.com/en/verify/52090914735727?ref=email",
        badge: aigpeGreenBelt,
        color: "#7CB342"
    },
    {
        name: "AIGPE Yellow Belt",
        title: "AIGPE Lean Six Sigma Certified Yellow Belt",
        issuer: "AIGPE",
        date: "2024",
        verifyUrl: "https://digitalcredentials.aigproexcellence.com/en/verify/50529246343557?ref=email",
        badge: aigpeYellowBelt,
        color: "#FFD600"
    }
];

const Certifications = () => {
    return (
        <div className="certifications-section">
            <div className="row">
                {certificatesData.map((cert, i) => (
                    <div className="col-12 col-md-6 mb-4" key={i}>
                        <div className="certificate-card" data-aos="fade-up" data-aos-delay={i * 100}>
                            <div className="certificate-badge">
                                {cert.badge ? (
                                    <img src={cert.badge} alt={`${cert.name} badge`} />
                                ) : (
                                    <div className="certificate-icon" style={{ color: cert.color }}>
                                        <i className={`fa ${cert.icon}`}></i>
                                    </div>
                                )}
                            </div>
                            <div className="certificate-content">
                                <h5 className="certificate-name poppins-font">{cert.name}</h5>
                                <p className="certificate-title open-sans-font">{cert.title}</p>
                                <div className="certificate-meta">
                                    <span className="issuer">
                                        <i className="fa fa-building"></i> {cert.issuer}
                                    </span>
                                    <span className="date">
                                        <i className="fa fa-calendar"></i> {cert.date}
                                    </span>
                                </div>
                                {cert.verifyUrl && (
                                    <a
                                        href={cert.verifyUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="verify-link"
                                    >
                                        <i className="fa fa-external-link"></i> Verify Certificate
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Certifications;
